import Box from "@mui/material/Box";

export default function Footer(props) {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          paddingTop: "20px",
          color: "secondary.main",
        }}
      >
        ©2024 MeIX Inc.
      </Box>
    </>
  );
}
